import { Outlet } from "react-router-dom";
import Header from "./header";


const Layout = () => {
    return (
        <div>
            <Header />
            <main>
                <Outlet /> {/* This is where the child pages will be rendered */}
            </main>
        </div>
    );
};

export default Layout;
